import { inject, NewInstance } from 'aurelia-framework';
import { ProjectService } from 'pages/quote-setup/projects/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), ProjectService, EventAggregator)
export class ProjectEditor {
    constructor(controller, validationController, projectService, ea) {
        this.controller = controller;
        this.projectService = projectService;
        this.ea = ea;
        this.project = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('name').required()
            .ensure('number').required()
            .ensure('sop').required()
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.project = await this.projectService.getById(model.id);
        }
    }

    attached() {
        this.uxBody.querySelector('input').focus();        
    }

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.project.id) {
                    await this.projectService.update(this.project);
                    toastr.success('Project was updated!');
                } else {
                    await this.projectService.create(this.project);
                    toastr.success('New project was created!');
                }
                this.ea.publish('projects:updated', this.project);
                this.controller.ok(this.project);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}
